import React from 'react'
import {Icon} from '@chakra-ui/react'

const HambuergGlassIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8C0 12.4183 3.58172 16 8 16C9.82004 16 11.4981 15.3922 12.8424 14.3685L22.3834 23.9095L23.7976 22.4953L14.2706 12.9684C15.3533 11.6037 16 9.87735 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                fill="currentColor"
            />
            <path d="M17 5H24V7H17V5Z" fill="currentColor" />
            <path d="M17 8H24V10H17V8Z" fill="currentColor" />
            <path d="M24 11H17V13H24V11Z" fill="currentColor" />
        </Icon>
    )
}

export default HambuergGlassIcon
